module.exports = __webpack_public_path__ + "img/product_5.3bfe2977.png";